import { fmtPeriod } from "@/lib/format";

export default function PageHeader({ overline, title, description, period, children }) {
    return (
        <div className="border-b border-fp-border bg-white/80 backdrop-blur-xl lg:sticky lg:top-0 z-10">
            <div className="px-4 sm:px-6 lg:px-12 py-5 lg:py-6">
                <div className="flex items-start justify-between gap-3 lg:gap-6 flex-wrap">
                    <div className="min-w-0 flex-1">
                        {overline && <div className="font-sans text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-fp-secondary mb-2 break-words">{overline}</div>}
                        <h1 className="font-serif text-2xl sm:text-3xl lg:text-5xl tracking-tight text-fp-ink leading-tight">{title}</h1>
                        {description && <p className="font-sans text-xs sm:text-sm text-fp-secondary mt-2 max-w-2xl">{description}</p>}
                    </div>
                    <div className="flex items-center gap-3 lg:gap-6 shrink-0 flex-wrap">
                        {period && (
                            <div className="text-right">
                                <div className="font-sans text-[10px] uppercase tracking-[0.2em] text-fp-muted">Reporting Period</div>
                                <div className="font-mono text-sm text-fp-ink mt-1">{fmtPeriod(period)}</div>
                            </div>
                        )}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
